<template>
  <div>
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <!-- Barra de informações da ligação -->

    <v-card class="d-inline-flex justify-space-around posicionamento" :class="`linha-total ${selectColor()}`" tile>
      <!-- Da esquerda para a direita, todos os espaçamentos horizontais são de ml-2. 
        O elemento que ocupar a última posição à direita precisa possuir um espaçamento de mx-2 ou ml-2 e mr-2.-->

      <div class="mt-3 ml-2 evitaQuebraDeLinha"><strong>Ramal: </strong> {{ ramalOperador() }}</div>

      <div v-show="exibeFila" class="mt-3 ml-2 evitaQuebraDeLinha"><strong v-show="exibeFila">Fila: </strong>
        {{ mostraFila() }}
      </div>

      <div class="mt-3 ml-2 evitaQuebraDeLinha"><strong>Tempo: </strong>{{ mostraTempo() }}</div>

      <div class="d-flex justify-space-between ml-2">
        <v-select dense style="min-width: 104px" outlined :items="pausas"
          :disabled="typeof agent !== 'undefined' && agent.paused === '1' ? true : false" v-model="pausa" label="Pausas"
          height="28" class="mt-1" background-color="background" light />

        <v-btn height="32" class="mt-2 ml-2" :dark="!disabledButton" color="bluePcm" :disabled="disabledButton"
          @click="pauseUnpauseMethod">
          {{ typeof agent !== 'undefined' && agent.paused === '1' ? 'Despausar' : 'Pausar' }}
        </v-btn>
      </div>

      <div class="d-flex justify-space-between ml-2" v-if="agent.channels.length === 0">
        <div class="d-flex align-center">
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn height="32" width="32" class="mr-2" icon color="white" dark @click="openNumbersList" v-bind="attrs"
                v-on="on">
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </template>
            <span>Lista de Números</span>
          </v-tooltip>
          <v-text-field v-show="agent.channels.length === 0" style="min-width: 104px" height="28" outlined
            background-color="background" light dense label="Número Ligação" class="mt-6" type="number"
            v-model="clickToCall" @keyup.enter.down="clickToCallMethod" />
        </div>

        <div class="d-flex align-center ml-2 mb-2">
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="agent.channels.length === 0" height="32" class="mt-2" color="bluePcm" dark
                @click="clickToCallMethod" v-bind="attrs" v-on="on" :loading="isLoadingNormalCall"
                :disabled="isLoadingNormalCall || isLoadingWhatsAppCall || isLoadingWhatsAppListCall">
                <v-icon small>mdi-phone</v-icon>
              </v-btn>
            </template>
            <span>Ligar pela Operadora</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-show="agent.channels.length === 0" height="32" class="mt-2 ml-2" color="bluePcm" dark
                @click="startWhatsAppCall" v-bind="attrs" v-on="on" :loading="isLoadingWhatsAppCall"
                :disabled="isLoadingWhatsAppCall || isLoadingNormalCall || isLoadingWhatsAppListCall">
                <v-icon small>mdi-whatsapp</v-icon>
              </v-btn>
            </template>
            <span>Ligar pelo WhatsApp</span>
          </v-tooltip>
        </div>
      </div>

      <div class="line-number mr-2" v-show="agent.channels.length > 0">
        <v-btn icon small v-show="agent.channels.length > 1" @click="prevCallOperador(agent.deviceId)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <strong class="ml-2" style="white-space: pre-wrap">Número: </strong>
        {{ mostraLigacoes(agent.channels, agent.callIndexOperador) }}
        <v-btn icon small v-show="agent.channels.length > 1" @click="nextCallOperador(agent.deviceId)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>

      <div class="line-number mr-2" v-show="agent.channels.length > 0">
        <strong class="ml-2" style="white-space: pre-wrap">Protocolo: </strong>
        <div id="protocol" @change="agent.channels.length > 0">{{ mostrarProtocolo(agent.channels,
          agent.callIndexOperador) }}</div>
        <v-btn @click="copytext()" icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </div>

    </v-card>

    <v-dialog v-model="dialogNumbersList" max-width="520">
      <v-card>
        <v-card-title class="title">Lista de Números</v-card-title>
        <v-card-text>
          <v-text-field dense outlined clearable prepend-inner-icon="mdi-magnify" label="Pesquisar"
            v-model="numbersListSearch" class="mt-2" @input="numbersListSearch = numbersOnly($event)"
            @keypress="preventNonNumericInput" />
          <div class="numbers-list-container" @scroll.passive="onNumbersListScroll">
            <v-list dense>
              <template v-if="filteredNumbersList.length">
                <v-list-item v-for="item in filteredNumbersList" :key="item.phoneNumber"
                  class="d-flex flex-row align-center number-list-item">
                  <v-list-item-icon class="mr-2 mt-3">
                    <v-icon small>mdi-phone-classic</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.phoneNumber }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action class="d-flex flex-row align-center justify-space-between no-right-padding">
                    <v-tooltip bottom open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mr-2" small
                          :color="item.status === 'accepted' && item.can_call ? 'bluePcm' : 'grey'" dark
                          @click="item.status === 'accepted' && item.can_call && callWhatsAppWithNumber(item.phoneNumber)"
                          :disabled="(item.status !== 'accepted' || !item.can_call) || isLoadingWhatsAppListCall || isLoadingWhatsAppCall || isLoadingNormalCall"
                          :loading="isLoadingWhatsAppListCall && item.phoneNumber === clickToCall" v-bind="attrs"
                          v-on="on">
                          <v-icon small>{{ item.status === 'accepted' ? 'mdi-whatsapp' : 'mdi-email-send' }}</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ item.status === 'accepted' ? 'Ligar pelo WhatsApp' : 'Enviar mensagem' }}</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="status-dot" v-bind="attrs" v-on="on" small
                          :color="item.status === 'accepted' && item.can_call ? 'green' : 'yellow darken-2'">mdi-circle</v-icon>
                      </template>
                      <span>{{ item.status === 'accepted' && item.can_call ? 'Disponível' : 'Pendente' }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <template v-else-if="isLoadingWhatsappNumbers">
                <v-list-item>
                  <v-list-item-content class="d-flex align-center">
                    <v-progress-circular indeterminate color="primary" size="24" class="mr-2"></v-progress-circular>
                    <v-list-item-title>Carregando...</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Nada Encontrado</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" class="mr-4" @click="dialogNumbersList = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para assinatura do WhatsApp -->
    <v-dialog v-model="dialogWhatsAppSubscription" max-width="400">
      <v-card>
        <v-card-title class="title">Recurso não disponível</v-card-title>
        <v-card-text>
          <p class="mb-3">Funcionalidade não disponível.</p>
          <p>Por favor, entre em contato com o comercial: 6239203372. Obrigado.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary"
            @click="dialogWhatsAppSubscription = false; isLoadingWhatsAppCall = false; isLoadingWhatsAppListCall = false; isLoadingNormalCall = false;">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para primeira interação com WhatsApp -->
    <v-dialog v-model="dialogWhatsAppFirstInteraction" max-width="450">
      <v-card>
        <v-card-title class="title">Permissão para WhatsApp</v-card-title>
        <v-card-text>
          <p class="mb-3">Para realizar chamadas via WhatsApp, é necessário enviar uma solicitação para este número.</p>
          <p>Deseja enviar uma solicitação para o número <strong>{{ clickToCall }}</strong>?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
            @click="dialogWhatsAppFirstInteraction = false; isLoadingWhatsAppCall = false; isLoadingWhatsAppListCall = false; isLoadingNormalCall = false;">Não</v-btn>
          <v-btn text color="primary" @click="sendWhatsAppTemplateAndCloseDialog">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para convite pendente do WhatsApp -->
    <v-dialog v-model="dialogWhatsAppPendingInvitation" max-width="450">
      <v-card>
        <v-card-title class="title">Solicitação pendente</v-card-title>
        <v-card-text>
          <p class="mb-3">Já existe uma solicitação pendente para este número.</p>
          <p>Aguarde até que o contato aceite a solicitação para poder realizar chamadas via WhatsApp.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary"
            @click="dialogWhatsAppPendingInvitation = false; isLoadingWhatsAppCall = false; isLoadingWhatsAppListCall = false; isLoadingNormalCall = false;">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import monitorScreen from '../store'

import Snackbar from '@/componentes/Snackbar'
import registerUserService from '@/utils/commomServices/registerUserService'
import searchPermissionServices from '@/utils/commomServices/searchPermissionServices'

import monitorScreenHttpServices from '../services/monitorScreenHttpServices'

export default {
  name: 'MainScreenOperator',
  components: { Snackbar },
  props: {
    clickToCallNewNumberRequest: String,
  },
  data: () => ({
    form: {
      // Barra
      agente: '',
      action: 'login',
      ramal: '',
      realizouEvento: 'Operador',
    },
    text: '',
    snackbar: false,
    status: 'Pausado',
    pausaDescription: 'Pausa do Ramal',
    clickToCall: '',
    pausas: [],
    pausa: '',
    operador: '',
    disabledButton: false,
    filas: [],
    exibeFila: false,
    EndListAgent: false,
    dialogNumbersList: false,
    numbersListSearch: '',
    numbersListAll: [],
    numbersList: [],
    numbersListPageSize: 10,
    numbersListVisibleCount: 10,
    isLoadingWhatsappNumbers: false,
    isLoadingWhatsAppCall: false,
    isLoadingWhatsAppListCall: false,
    isLoadingNormalCall: false,
    hasWhatsAppIntegration: false,
    dialogWhatsAppSubscription: false,
    dialogWhatsAppFirstInteraction: false,
    dialogWhatsAppPendingInvitation: false,
    whatsAppErrorData: null,
  }),

  computed: {
    ...mapGetters(['getRamais', 'getprotocoloChamadas', 'getEndListAgent']),
    ...mapGetters('monitorScreen', ['getFilas']),

    agent() {
      const base = {
        channels: [],
        callIndex: 0,
        callIndexOperador: 0,
        paused: '0',
        time: '',
        arrayQueues: [],
        queueEnters: [],
        reason: '',
        isNotRegistered: false,
      }
      let agente = null
      this.getRamais.forEach(ramal => {
        if (this.operador && this.operador.length > 0 && typeof ramal.agent !== 'undefined') {
          if (ramal.agent.indexOf(`-${this.operador}`) > 0) {
            agente = Object.assign({}, base, ramal)
          }
        }
      })
      return agente || base
    },
    endListAgent() {
      if (this.getEndListAgent == true && this.EndListAgent == true) {
        return true
      } else {
        return false
      }
    },

    filteredNumbersList() {
      const query = (this.numbersListSearch || '').toString().trim()
      if (!query) return this.numbersList
      const normalized = query.replace(/\D/g, '')
      return this.numbersList.filter((item) => item.phoneNumber.includes(normalized))
    },
  },

  async created() {
    registerVuexModule(this.$store, 'monitorScreen', monitorScreen)
    this.operador = localStorage.getItem('operador_logado')
    const tokenOperador = localStorage.getItem('pcm_access_token_operador')

    // Verificar status da integração com WhatsApp
    try {
      const whatsappConfigResponse = await monitorScreenHttpServices.getWhatsappConfig()
      this.hasWhatsAppIntegration = whatsappConfigResponse.data.has_integration
      // console.log('Status da integração WhatsApp:', this.hasWhatsAppIntegration)
    } catch (error) {
      console.error('Erro ao verificar integração WhatsApp:', error)
      this.hasWhatsAppIntegration = false
    }

    if (this.operador && tokenOperador) {
      try {
        const response = await searchPermissionServices.getMe(tokenOperador)

        const permissionNames = response.data.permissions.map(permission => permission.name)
        if (permissionNames.includes(process.env.VUE_APP_CALLCENTER_OPERADOR)) {
          const responseVerificaLogin = await monitorScreenHttpServices.verificaLogin(this.operador)
          if (typeof responseVerificaLogin.data === 'string') {
            localStorage.removeItem('operador_logado')
            localStorage.removeItem('pcm_access_token_operador')
            this.$router.push({ name: 'loginOperador' })
          }
        }
        const getFilas = await monitorScreenHttpServices.getFilas()
        this.filas = getFilas.data.map(fila => ({ _id: fila._id, description: fila.description }))

        this.form.agente = this.operador

        const pausas = await monitorScreenHttpServices.getPausasOperador()

        this.pausas = pausas.data.map(pausa => ({ text: pausa.description, value: pausa._id }))

        if (this.pausas.length > 0) {
          this.pausas = this.pausas.filter((pausa) => pausa.text !== 'autopause')
        }

        if (this.agent.paused === '1') {
          const indexPausa = this.pausas.findIndex(pausaIndividual => pausaIndividual.text === this.agent.reason)
          if (indexPausa !== -1) {
            this.pausa = this.pausas[indexPausa].value
          }
        }

      } catch (err) {
        console.log(err, 'ERROR')
      }
    }
    this.EndListAgent = true

    // A lista de números será carregada quando o botão for clicado
  },

  methods: {
    ...mapActions(['prevCallOperador', 'nextCallOperador']),
    /**
     * Processa o JSON de erro retornado pelo backend para determinar o tipo de erro de WhatsApp
     * @param {Object} error - Objeto de erro retornado pelo catch
     * @returns {Object} Objeto com informações sobre o tipo de erro e ação recomendada
     */
    processWhatsAppError(error) {
      const result = {
        errorType: 'unknown',
        message: 'Erro ao realizar a ligação pelo WhatsApp',
        canSendTemplate: false,
        rawError: error,
        additionalData: {}
      }

      const resp = error && error.response ? error.response : null
      const data = resp && resp.data ? resp.data : {}
      const status = resp ? resp.status : null

      // Mapeia pelos status do backend
      if (status === 403) {
        // "Número não possui permissão para ligar" -> precisa enviar template
        result.errorType = 'first_interaction'
        result.message = data?.error || 'Número sem permissão para ligar pelo WhatsApp'
        result.canSendTemplate = true
      } else if (status === 409) {
        // "Já existe uma solicitação não aceita" -> convite pendente
        result.errorType = 'pending_invitation'
        result.message = data?.error || 'Já existe uma solicitação pendente para este número'
      } else {
        // Fallback por mensagem
        const msg = (data?.error || data?.message || '').toString().toLowerCase()
        if (msg.includes('permiss') || msg.includes('permission')) {
          result.errorType = 'first_interaction'
          result.message = data?.error || 'É necessário enviar um convite antes da chamada'
          result.canSendTemplate = true
        } else if (msg.includes('pendente') || msg.includes('pending')) {
          result.errorType = 'pending_invitation'
          result.message = data?.error || 'Já existe uma solicitação pendente para este número'
        }
      }

      result.additionalData = data
      return result
    },

    numbersOnly(value) {
      return (value || '').toString().replace(/\D/g, '')
    },

    preventNonNumericInput(event) {
      // Permite apenas teclas numéricas (0-9)
      const keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    prefillNumber(number) {
      this.clickToCall = number
      this.dialogNumbersList = false
    },

    /**
     * Preenche o número e inicia a chamada WhatsApp diretamente
     * @param {string} number - Número de telefone para chamar
     */
    callWhatsAppWithNumber(number) {
      this.clickToCall = number
      this.dialogNumbersList = false
      // Ativar o estado de loading para o botão da lista
      this.isLoadingWhatsAppListCall = true
      this.startWhatsAppCall()
    },

    async openNumbersList() {
      // Verificar se há integração com WhatsApp
      if (!this.hasWhatsAppIntegration) {
        this.dialogWhatsAppSubscription = true
        return
      }

      try {
        this.isLoadingWhatsappNumbers = true
        this.dialogNumbersList = true
        const whatsappNumbers = await monitorScreenHttpServices.getWhatsappNumbers()
        this.numbersListAll = whatsappNumbers.data.map(item => ({
          phoneNumber: item.number,
          status: item.status,
          can_call: item.can_call
        }))
        this.numbersListVisibleCount = this.numbersListPageSize
        this.numbersList = this.numbersListAll.slice(0, this.numbersListVisibleCount)
      } catch (err) {
        console.error('Erro ao buscar números do WhatsApp:', err)
        this.numbersListAll = []
        this.numbersList = []
      } finally {
        this.isLoadingWhatsappNumbers = false
      }
    },
    onNumbersListScroll(evt) {
      const el = evt.target
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 8) {
        const nextCount = this.numbersListVisibleCount + this.numbersListPageSize
        if (nextCount <= this.numbersListAll.length) {
          this.numbersListVisibleCount = nextCount
          this.numbersList = this.numbersListAll.slice(0, this.numbersListVisibleCount)
        }
      }
    },

    selectColor() {
      if (
        typeof this.agent.channels !== 'undefined' &&
        this.agent.channels.length > 0 &&
        this.agent.channels[this.agent.callIndex].state
      ) {
        if (
          this.agent.channels[this.agent.callIndex].state === 'RING' ||
          this.agent.channels[this.agent.callIndex].state === 'RINGING'
        ) {
          return 'operator-background-color-orange'
        } else if (this.agent.channels[this.agent.callIndex].state === 'UP') {
          return 'operator-background-color-red'
        }
      }

      if (this.agent.paused === '1') {
        return 'operator-background-color-yellow'
      }

      if (this.agent.isNotRegistered == true) {
        return 'operator-background-color-gray'
      }

      return 'operator-background-color-green'
    },

    ramalOperador() {
      let operador = ''
      this.getRamais.forEach(ramal => {
        if (typeof ramal.agent !== 'undefined') {
          if (ramal.agent.indexOf(`-${this.operador}`) > 0) {
            operador = ramal.deviceId
          }
        }
      })
      return operador
    },

    // mostraFila(){
    //   console.log(this.filas)
    //   return this.agent
    // },

    mostraFila() {
      let key = this.agent.callIndex

      if (this.agent.channels && typeof this.agent.channels[key] !== 'undefined' && this.agent.channels[key].io ===
        'incoming') {
        let queueByCall = ''
        this.exibeFila = true
        if (this.filas && this.agent.queueEnters[key]) {
          const indexQueue = this.filas.findIndex(queue => queue._id === this.agent.queueEnters[key].queue)
          if (indexQueue !== -1) {
            queueByCall = this.filas[indexQueue].description
            if (queueByCall.length > 10) {
              return this.limitaNumeroDeCaracteresQueue(queueByCall)
            }
            return queueByCall
          }
        }
        return 'D'
      }
      this.exibeFila = false
      return "---"
    },

    limitaNumeroDeCaracteresQueue(queue) {
      if (queue.length > 22 && window.innerWidth > 1200) {
        let arrayQueue = queue.split('')
        arrayQueue.splice(22)
        arrayQueue.push('...')
        let nomeQueueAlterado = arrayQueue.join('')
        return nomeQueueAlterado
      } else if (queue.length > 10 && window.innerWidth <= 1200) {
        let arrayQueue = queue.split('')
        arrayQueue.splice(10)
        arrayQueue.push('...')
        let nomeQueueAlterado = arrayQueue.join('')
        return nomeQueueAlterado
      }

      return queue
    },

    mostraTempo() {
      if (!this.agent.channels || this.agent.channels.length === 0) {
        return this.agent.time || '00:00:00'
      }
      const ch = this.agent.channels[this.agent.callIndexOperador] || this.agent.channels[0]
      return ch && ch.time ? ch.time : '00:00:00'
    },

    mostraLigacoes(arrayLigacoes, index) {
      if (arrayLigacoes.length > 0) {
        return arrayLigacoes[index].phoneNumber
      }
      return ''
    },

    mostrarProtocolo(arrayLigacoes, index) {
      if (arrayLigacoes.length > 0) {
        const indexProtocolo = this.getprotocoloChamadas.findIndex(protocolo => arrayLigacoes[index].linkedId_uniqueId
          .split('_')[0] == protocolo.uniqueId && arrayLigacoes[index].linkedId_uniqueId.split('_')[0] == protocolo
            .linkedId)
        if (indexProtocolo >= 0) {
          let protocolos = JSON.parse(this.getprotocoloChamadas[indexProtocolo].protocolos)
          return protocolos[0]
        }
      }
      return ''
    },

    copytext() {
      navigator.clipboard.writeText(document.getElementById('protocol').textContent);
    },

    async clickToCallMethod() {
      console.log('inicio click to call')

      this.snackbar = false
      if (this.clickToCall === '') {
        this.text = 'Favor digitar um número para realizar a ligação'
        this.snackbar = true
        return
      }

      try {
        // Ativar estado de loading
        this.isLoadingNormalCall = true

        // Modo de ligação normal
        const clickToCallForm = {
          endpoint: this.ramalOperador(),
          destino: this.clickToCall,
        }
        // console.log(clickToCallForm, 'formulario click to call')
        await monitorScreenHttpServices.clickToCallMethod(clickToCallForm)
        // console.log('Executou a requisicao click to call')
      } catch (error) {
        // console.error('Erro ao realizar chamada:', error)
        this.text = 'Erro ao realizar chamada'
        this.snackbar = true
      } finally {
        // Desativar estado de loading
        this.isLoadingNormalCall = false
      }
    },

    async sendWhatsAppTemplate() {
      console.log('inicio envio de template WhatsApp')

      this.snackbar = false
      if (this.clickToCall === '') {
        this.text = 'Favor digitar um número para enviar mensagem WhatsApp'
        this.snackbar = true
        return
      }

      try {
        const whatsappData = {
          number: this.clickToCall
        }
        await monitorScreenHttpServices.sendWhatsappTemplate(whatsappData)
        console.log('Executou a requisição de template WhatsApp')
        return true
      } catch (error) {
        console.error('Erro ao enviar template WhatsApp:', error)
        this.text = 'Erro ao enviar mensagem de WhatsApp'
        this.snackbar = true
        return false
      }
    },

    async sendWhatsAppTemplateAndCloseDialog() {
      const success = await this.sendWhatsAppTemplate()
      this.dialogWhatsAppFirstInteraction = false

      // Garantir que o estado de loading seja desativado
      this.isLoadingWhatsAppCall = false
      this.isLoadingWhatsAppListCall = false
      this.isLoadingNormalCall = false

      if (success) {
        this.text = 'Convite para chamada enviado via WhatsApp'
        this.snackbar = true
      }
    },

    async startWhatsAppCall() {
      console.log('Iniciando chamada WhatsApp')

      // Verificar se há integração com WhatsApp
      if (!this.hasWhatsAppIntegration) {
        this.dialogWhatsAppSubscription = true
        return
      }

      this.snackbar = false
      if (this.clickToCall === '') {
        this.text = 'Favor digitar um número para realizar a ligação pelo WhatsApp'
        this.snackbar = true
        return
      }

      // Ativar o estado de loading
      this.isLoadingWhatsAppCall = true

      try {
        // Preparar os parâmetros para a chamada WhatsApp
        const clickToCallForm = {
          endpoint: this.ramalOperador(),
          destino: this.clickToCall,
        }

        // Fazer a requisição direta para o endpoint de click-to-call do WhatsApp
        await monitorScreenHttpServices.whatsappClickToCall(clickToCallForm)
        console.log('Executou a requisição de click-to-call WhatsApp')
      } catch (error) {
        console.error('Erro ao iniciar chamada WhatsApp:', error)

        // Processar o erro para determinar o tipo e ação apropriada
        const errorResult = this.processWhatsAppError(error)
        this.whatsAppErrorData = errorResult

        // Exibir o modal apropriado com base no tipo de erro
        switch (errorResult.errorType) {
          case 'first_interaction':
            // Primeira interação - exibir modal perguntando se deseja enviar solicitação
            this.dialogWhatsAppFirstInteraction = true
            break

          case 'pending_invitation':
            // Convite pendente - exibir modal informando sobre solicitação não aceita
            this.dialogWhatsAppPendingInvitation = true
            break

          default:
            // Erro desconhecido - exibir mensagem genérica
            this.text = errorResult.message
            this.snackbar = true
            break
        }
      } finally {
        // Desativar o estado de loading independente do resultado
        this.isLoadingWhatsAppCall = false
        this.isLoadingWhatsAppListCall = false
      }
    },

    async pauseUnpauseMethod() {
      console.log('inicio pause/unpause method')
      this.disabledButton = true
      let data
      this.snackbar = false
      if (typeof this.agent !== 'undefined' && (!this.agent.paused || this.agent.paused === '0')) {
        if (this.pausa === '') {
          this.text = 'Favor escolher o motivo da pausa.'
          this.snackbar = true
          this.disabledButton = false
          return
        }
        data = {
          agente: this.operador,
          action: 'pause',
          pause_id: this.pausa,
          realizouEvento: 'Operador'
        }
      } else {
        data = {
          agente: this.operador,
          action: 'unpause',
          realizouEvento: 'Operador'
        }
        this.pausa = ''
      }

      console.log(data, 'formulario pause/unpause method.')
      await monitorScreenHttpServices.acoesOperador(data)
      this.disabledButton = false
      console.log('Executou a requisicao pause/unpause method')
    },

    async forcedOperadorLogout() {
      await registerUserService.loginOperador({
        action: 'logout',
        realizouEvento: 'Operador',
        agente: localStorage.getItem('operador_logado'),
      })
      localStorage.removeItem('pcm_access_token_operador')
      localStorage.removeItem('operador_logado')

      this.$router.push({ name: 'loginOperador' })
    },
  },

  watch: {
    clickToCallNewNumberRequest: function (newNumber,) {
      this.clickToCall = newNumber
    },
    agent: {
      deep: true,
      async handler(novo, antigo) {
        if (novo.paused !== antigo.paused && this.pausas) {
          this.pausas.forEach(pausaIndividual => {
            if (this.agent.reason === pausaIndividual.text && this.pausa !== pausaIndividual.value) {
              this.pausa = pausaIndividual.value
            }
          })
        }
        if (
          (Object.keys(novo).length === 0 && this.endListAgent == true) ||
          (typeof novo.agent === 'undefined' && typeof antigo.agent !== 'undefined') ||
          (novo.arrayQueues.length === 0 && antigo.arrayQueues.length > 0) ||
          (novo.arrayQueues && antigo.arrayQueues && novo.arrayQueues.length < antigo.arrayQueues.length)
        ) {
          await this.forcedOperadorLogout()
        }
      },
    },
  },
}
</script>

<style scoped>
/* Barra com dados da chamada */
.linha-total {
  width: 100vw;
  height: 52px;
  padding-top: 2px;
}

.evitaQuebraDeLinha {
  white-space: nowrap;
}

.line-number {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 3px;
}

.operator-background-color-green {
  background-color: #3A811D;
  color: white;
}

.operator-background-color-yellow {
  background-color: #FBC400;
}

.operator-background-color-orange {
  background-color: var(--v-orangePcm-base);
}

.operator-background-color-red {
  background-color: var(--v-darkRed-base);
}

.operator-background-color-gray {
  background-color: var(--v-gray-base);
  color: white;
}

.posicionamento {
  z-index: 3;
}

/* Fim da barra com dados da chamada */

.numbers-list-container {
  max-height: 320px;
  overflow: hidden;
  scrollbar-gutter: stable;
}

.numbers-list-container:hover {
  overflow-y: auto;
}

.numbers-list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.numbers-list-action {
  display: inline-flex;
  align-items: center;
}

.status-dot {
  margin: 0;
}

.action-btn {
  width: 80px;
  min-width: 80px;
  justify-content: center;
}

.number-list-item {
  padding-right: 0 !important;
}

.no-right-padding {
  padding-right: 0 !important;
  margin-right: 0 !important;
}
</style>